module.exports = __webpack_public_path__ + "img/img-stop-jubitz.6b36ea37.png";